<template>
  <div class="wrapper grid-x" :class="{ '-full-width': fullWidth }">
    <div class="cell small-12 small-order-2" :class="textGridClasses">
      <v-text
        class="text-content"
        :class="{ '-right': imageLeft, '-full-width': fullWidth }"
        :isWhite="fullWidth"
        :text="text"
      />
    </div>
    <div class="cell small-12 small-order-1" :class="imageGridClasses">
      <img
        class="image"
        :src="image.url"
        :width="image.width"
        :height="image.height"
        :alt="image.title"
      />
    </div>
  </div>
</template>

<script>
import VText from "./Text";

export default {
  props: {
    text: Array,
    image: Object,
    imageLeft: Boolean,
    contain: Boolean,
    fullWidth: Boolean,
  },
  components: {
    VText,
  },
  computed: {
    textGridClasses() {
      let classes = [];
      if (this.contain && !this.imageLeft) {
        classes.push("medium-5");
        classes.push("medium-offset-1");
      } else if (this.contain && this.imageLeft) {
        classes.push("medium-5");
      } else if (this.fullWidth) {
        classes.push("medium-4");
      } else {
        classes.push("medium-6");
      }
      if (this.imageLeft) {
        classes.push("medium-order-2");
      } else {
        classes.push("medium-order-1");
      }
      return classes;
    },
    imageGridClasses() {
      let classes = [];
      if (this.contain && !this.imageLeft) {
        classes.push("medium-5");
      } else if (this.contain && this.imageLeft) {
        classes.push("medium-5");
        classes.push("medium-offset-1");
        classes.push("medium-order-1");
      } else if (this.fullWidth && !this.imageLeft) {
        classes.push("medium-8");
      } else if (this.fullWidth && this.imageLeft) {
        classes.push("medium-8");
        classes.push("medium-order-1");
      } else {
        classes.push("medium-6");
      }
      if (this.imageLeft) {
        classes.push("medium-order-1");
      } else {
        classes.push("medium-order-2");
      }
      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.wrapper {
  margin: {
    top: vw-relative(12, 320);
    bottom: vw-relative(12, 320);
  }
  &.-full-width {
    background-color: #6b2377;
    margin: 0 0 0 -4.5%;
    width: 109%;
    @include breakpoint(medium) {
      margin: 0 0 0 -10%;
      width: 120%;
    }
  }
  @include breakpoint(medium) {
    margin: {
      top: vw-relative(40);
      bottom: vw-relative(40);
    }
  }
}
.image {
  width: 100%;
  height: auto;
}
.text-content {
  padding-top: 20px;
  &.-full-width {
    padding: 9% 4.5%;
    @include breakpoint(medium) {
      padding: 9.6% 12%;
    }
  }
  @include breakpoint(medium) {
    padding-right: vw-relative(32);
    padding-top: 0;
    &.-right {
      padding-right: 0;
      padding-left: vw-relative(32);
    }
  }
}
</style>
